export enum CardsNumber {
  MY_LIST = 5,
  SEARCH = 3,
}
